"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Layer = _interopRequireDefault(require("../Layer"));

var __jsx = _react["default"].createElement;

function Dialog$(props) {
  return __jsx(_Layer["default"], (0, _extends2["default"])({}, props, {
    focusLock: true
  }));
}

var _default = Dialog$;
exports["default"] = _default;